import { render, staticRenderFns } from "./list.vue?vue&type=template&id=c6c07baa&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=c6c07baa&prod&lang=less&scoped=true&"
import style1 from "./list.vue?vue&type=style&index=1&id=c6c07baa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c07baa",
  null
  
)

export default component.exports